import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IPredictiveModelAction } from '../../../../ts/ServerApi/types/actionNames';
import { newPredictiveModelForDatasource } from '../../../actions/spaces/NewPredictiveModelForDatasourceAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';
export const NewPredictiveModelEntityAction: IEntityAction<IContentInfo<'datasource'>, IPredictiveModelAction> = {
  name: EntityActionNames.NewPredictiveModel,
  translateName: Messages.newPredictiveModel,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.prometheusPredictiveModelEnabled && !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IPredictiveModelAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 &&availableActions && availableActions.createPredictiveModel ,
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return newPredictiveModelForDatasource(item);
    }
  }
};
